import React, { useState, useEffect } from 'react';
import { X, Layers, Save, Loader, ArrowRight } from 'lucide-react';
import { db } from '../../db';
import { syncManager } from '../../services/sync';

const ConversionModal = ({ onClose }) => {
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [users, setUsers] = useState([]);
    const [programs, setPrograms] = useState([]);

    const [formData, setFormData] = useState({
        userEmail: '',
        newRole: 'CLIENT',
        targetProgram: '',
        notes: ''
    });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const rawUsers = await syncManager.fetchTabData('Users');
            if (rawUsers) {setUsers(rawUsers);}

            const prodData = await db.tabData.where('tabName').equals('Master_Products').first();
            if (prodData?.data) {
                setPrograms(prodData.data.map(p => p.Product_Name).filter(Boolean));
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await syncManager.triggerWorkflow('hq-convert-user', formData);
            alert('User conversion triggered!');
            onClose();
        } catch (error) {
            alert('Error: ' + error.message);
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) {return <div className="p-10 text-center"><Loader className="animate-spin mx-auto" /></div>;}

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full overflow-hidden animate-in zoom-in-95 duration-200">
                <div className="bg-slate-50 border-b border-slate-100 p-6 flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <div className="bg-blue-100 p-2 rounded-xl text-blue-600">
                            <Layers size={20} />
                        </div>
                        <h2 className="text-xl font-black text-slate-800">Convert / Upgrade</h2>
                    </div>
                    <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full text-slate-400">
                        <X size={20} />
                    </button>
                </div>
                <div className="p-6">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Select User</label>
                            <select required value={formData.userEmail} onChange={e => setFormData({ ...formData, userEmail: e.target.value })} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl">
                                <option value="">-- Choose User --</option>
                                {users.map(u => <option key={u.Client_Email} value={u.Client_Email}>{u.Client_Name} ({u.Client_Email})</option>)}
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">New Role</label>
                            <select value={formData.newRole} onChange={e => setFormData({ ...formData, newRole: e.target.value })} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl">
                                <option value="CLIENT">Full Client</option>
                                <option value="COACH">Coach</option>
                                <option value="PARTNER">Partner</option>
                                <option value="ADMIN">Admin</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-slate-500 uppercase mb-1">Target Program</label>
                            <select value={formData.targetProgram} onChange={e => setFormData({ ...formData, targetProgram: e.target.value })} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl">
                                <option value="">-- No Change --</option>
                                {programs.map(p => <option key={p} value={p}>{p}</option>)}
                            </select>
                        </div>
                        <button type="submit" disabled={submitting} className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold uppercase tracking-widest flex items-center justify-center gap-2">
                            {submitting ? <Loader className="animate-spin" /> : <><ArrowRight size={20} /> Upgrade Account</>}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ConversionModal;
